/* global SUPER_EIGO_CONTEXT_PATH, SUPER_EIGO_VC2_CONTEXT_PATH */

import $ from 'jquery';
import openWindow from '../utils/openWindowUtils';
import getNoCacheRandomString from '../utils/URLUtiles';

function openFlashWindow() {
  window.open('../../mem/flash.html', 'mywindow1', 'width=820, height=580, menubar=no, toolbar=no, scrollbars=yes');
}

/**
 * Visionary MyPortforlio画面を開く
 */
function openVcMyPortfolioWindow(user_id) {
  const url = `/${SUPER_EIGO_CONTEXT_PATH}/admin/vc_myportfolio/PortfolioWindow.cfm?user_id=${user_id}`;
  const options = {
    name: 'mywindow1',
    width: 1050,
    height: 700,
  };
  openWindow(url, options);
}
/**
 * Portforlio画面を開く
 */
function openPortfolioWindow(user_id) {
  const url = `../userPortfolio/cpPortfolioWindow.cfm?user_id=${user_id}`;
//  if (typeof SUPER_EIGO_VC2_CONTEXT_PATH !== 'undefined') {
//    url = `/${SUPER_EIGO_VC2_CONTEXT_PATH}/myportfolio/preview/${user_id}`;
//  }
  const options = {
    name: 'mywindow1',
    width: 1000,
    height: 700,
  };
  openWindow(url, options);
}


/**
 * 受講者アサイン画面を開く
 */
function openAddClassUserWindow(rno) {
  const url = `assign/addUserWindowSearch.cfm?rno=${rno}`;
  const options = {
    name: 'mywindow1',
    width: 980,
    height: 700,
  };
  openWindow(url, options);
}
/**
 * 受講者簡単アサイン画面を開く
 */
function openAddClassUserForIdWindow(rno) {
  const url = `assign/addUserWindowKantan.cfm?rno=${rno}`;
  const options = {
    name: 'mywindow1',
    width: 980,
    height: 700,
  };
  openWindow(url, options);
}
/**
 * クラス選択画面を開く
 */
function openDeleteClassUserWindow(rno) {
  const url = `assign/deleteUserWindow.cfm?rno=${rno}`;
  const options = {
    name: 'mywindow1',
    width: 980,
    height: 700,
  };
  openWindow(url, options);
}


/**
 * クラス選択画面を開く
 */
function openEditSchrduleWindow(rno, category_no) {
  const url = `EditScheduleWindow.cfm?rno=${rno}&category_no=${category_no}`;
  const options = {
    name: 'mywindow1',
    width: 1000,
    height: 700,
  };
  openWindow(url, options);
}

/**
 * クラスからのお知らせを公開する
 */
function info_release(no) {
  $.getJSON('../../flash/info.cfc?method=fnc_open_class_info', {
    class_info_no: no,
    _CF_NODEBUG: true,
    rand: getNoCacheRandomString(),
  }, (json) => {
    if (json.success) {
      $(`#open_button_${no}`).hide();
      $(`#open_${no}`).show();
      alert('公開しました。');// eslint-disable-line no-alert
    } else {
      alert(`公開処理を失敗しました。\n\n${json.err_msg}`);// eslint-disable-line no-alert
    }
  });
}
/**
 * メール宛先選択画面を開く
 */
function openSendMailWindow(rno) {
  const url = `../sendMail/input_mail.cfm?rno=${rno}`;
  const options = {
    name: 'mailWindow1',
    width: 980,
    height: 700,
  };
  openWindow(url, options);
}

/**
 * メール宛先選択画面を開く(契約登録メール専用)
 * con:契約番号
 * type:種類
 * cnt:追加人数
 */
function openSendMailContractWindow(con, type, cnt) {
  const url = `input_mail_contract.cfm?con=${con}&type=${type}&cnt=${cnt}`;
  const options = {
    name: 'mailWindowtest',
    width: 980,
    height: 700,
  };
  openWindow(url, options);
}
/**
 * メール宛先選択画面を開く
 */
function openMailUserSearchWindow(rno) {
  const url = `addUserSearch.cfm?rno=${rno}`;
  const options = {
    name: 'mailWindow2',
    width: 980,
    height: 700,
  };
  openWindow(url, options);
}

/**
 * 受講者選択画面を開く（ブック）
 * 2014/05/16
 */
function openUserSearchWindow(cwno, ctno, agn) {
  const url = `addUserSearch.cfm?cwno=${cwno}&ctno=${ctno}&agn=${agn}`;
  const options = {
    name: 'userWindow',
    width: 980,
    height: 700,
  };
  openWindow(url, options);
}
/**
 * 受講者選択画面を開く(レポート・アンケート)
 * 2014/06/03
 */
function openUserSearchQuestWindow(cno, ano, book_type, mode) {
  const url = `addUserSearch.cfm?cno=${cno}&ano=${ano}&book_type=${book_type}&mode=${mode}`;
  const options = {
    name: 'userWindow',
    width: 980,
    height: 700,
  };
  openWindow(url, options);
}

// function openMileTableWindow(user_id) {
//   const winNew = window.open(`../userPortfolio/mileTable.cfm?user_id=${user_id}`, 'mywindow2', 'width=750, height=600, menubar=no, toolbar=no, scrollbars=yes');
//   if (!winNew) {
//     getSwfById('portfolioFlex').openWindowFromSwf('../userPortfolio/mileTable.cfm');
//   } else {
//     winNew.focus();
//   }
// }
// function openVCMileTableWindow(user_id, totalMile) {
//   const winNew = window.open(`../vc_myportfolio/mileTable.cfm?totalMile=${totalMile}&user_id=${user_id}`, 'mywindow2', 'width=750, height=600, menubar=no, toolbar=no, scrollbars=yes');
//   if (!winNew) {
//     getSwfById('portfolioFlex').openWindowFromSwf('../vc_myportfolio/mileTable.cfm');
//   } else {
//     winNew.focus();
//   }
// }


/**
 * Bookプレビュー画面を開く
 * @param course_no
 * @return
 */
function openBookPreviewWindow(course_no) {
  const url = `/${SUPER_EIGO_CONTEXT_PATH}/lplayer/index.cfm?course_no=${course_no}&previewType=book&isPreview=true`;
  const options = {
    name: 'mywindow2',
    width: 1000,
    height: 700,
  };
  openWindow(url, options);
}
/**
 * Bookプレビュー画面を開く
 * @param course_no
 * @return
 */
function openContractBookPreviewWindow(course_no, schm) {
  const url = `/${SUPER_EIGO_CONTEXT_PATH}/lplayer/index.cfm?course_no=${course_no}&previewType=book&isPreview=true&authoring_schema=${schm}`;
  const options = {
    name: 'mywindow2',
    width: 1000,
    height: 700,
  };
  openWindow(url, options);
}
/**
 * アサイン済みBookプレビュー画面を開く
 * @param course_no
 * @return
 */
function openAssignPreviewWindow(assign_no, isPreview) {
  const url = `/${SUPER_EIGO_CONTEXT_PATH}/lplayer/index.cfm?assign_no=${assign_no}&previewType=assign&isPreview=${isPreview}`;
  const options = {
    name: 'mywindow2',
    width: 1000,
    height: 700,
  };
  openWindow(url, options);
}
/**
 * Questionプレビュー画面を開く
 * @param course_no
 * @param question_no
 * @return
 */
function openSingleQuestionPreviewWindow(course_no, question_no) {
  const url = `../../../lplayer/index_waku.cfm?course_no=${course_no}&previewType=single&question_no=${question_no}&isPreview=true`;
  const options = {
    name: 'mywindow2',
    width: 1000,
    height: 700,
  };
  openWindow(url, options);
}
/**
 * Questionプレビュー画面を開く
 * @param question_no
 * @return
 */
function openQuestionPreviewWindow(question_no) {
  const url = `/${SUPER_EIGO_CONTEXT_PATH}/lplayer/index_waku.cfm?previewType=single&question_no=${question_no}&isPreview=true`;
  const options = {
    name: 'mywindow2',
    width: 1000,
    height: 700,
  };
  openWindow(url, options);
}
/**
 * Questionプレビュー画面を開く
 * @param question_no
 * @return
 */
function openContractQuestionPreviewWindow(question_no, schm) {
  const url = `/${SUPER_EIGO_CONTEXT_PATH}/lplayer/index.cfm?previewType=single&question_no=${question_no}&isPreview=true&authoring_schema=${schm}`;
  const options = {
    name: 'mywindow2',
    width: 1000,
    height: 700,
  };
  openWindow(url, options);
}
/**
 * 週刊！英語ドリル（オーサリング）プレビュー画面を開く
 * @param drill_no
 * @param dub_no
 * @return
 */
function openWeeklyPreviewWindow(drill_no, sub_no) {
  const url = `/${SUPER_EIGO_CONTEXT_PATH}/lplayer/weeklyDrill.cfm?drill_no=${drill_no}&sub_no=${sub_no}`;
  const options = {
    name: 'mywindow2',
    width: 1000,
    height: 700,
  };
  openWindow(url, options);
}
/**
 * VCETスコア詳細画面を開く
 * @param course_no
 * @return
 */
function openVCResultWindow(rno, batch_date, class_end_flg, batch_date_string) {
  const url = `/${SUPER_EIGO_CONTEXT_PATH}/admin/officePortfolio/vcet_d.cfm?rno=${rno}&batch_date=${batch_date}&class_end_flg=${class_end_flg}&batch_date_string=${batch_date_string}`;
  const options = {
    name: 'scoreWindow',
    width: 800,
    height: 800,
  };
  openWindow(url, options);
}
/**
 * VCETスコア詳細画面を開く
 */
function openVCMyPortfolioResultWindow(user_id, company_cd) {
  const url = `vcet_d.cfm?user_id=${user_id}&company_cd=${company_cd}`;
  const options = {
    name: 'scoreWindow',
    width: 800,
    height: 800,
  };
  openWindow(url, options);
}
/**
 * ブック詳細画面を開く
 */
function openVCCorseworkWindow(user_id, course_no) {
  const url = `/${SUPER_EIGO_CONTEXT_PATH}/admin/officePortfolio/coursework.cfm?frommyport=1&user_id=${user_id}&course_no=${course_no}`;
  const options = {
    name: 'scoreWindow',
    width: 1000,
    height: 800,
  };
  openWindow(url, options);
}
/**
 * VCET受講状況画面を開く
 */
function openVCListWindow(rno, vctest_no, contract_no, batch_date_string) {
  const url = `/${SUPER_EIGO_CONTEXT_PATH}/admin/officePortfolio/vcet_user.cfm?vctest_no=${vctest_no}&contract_no=${contract_no}&rno=${rno}&batch_date_string=${batch_date_string}`;
  const options = {
    name: 'vcetWindow',
    width: 1000,
    height: 700,
  };
  openWindow(url, options);
}
/**
 * VCET再受験設定画面を開く
 */
function openVCResetListWindow(rno, vctest_no, contract_no, batch_date_string) {
  const url = `/${SUPER_EIGO_CONTEXT_PATH}/admin/officePortfolio/vcet_user.cfm?rno=${rno}&batch_date_string=${batch_date_string}`;
  const options = {
    name: 'vcetWindow',
    width: 1000,
    height: 700,
  };
  openWindow(url, options);
}
/**
 * ブック詳細画面を開く
 */
function openCWDetailListWindow(rno, batch_date, class_end_flg, course_no, batch_date_string) {
  const url = `/${SUPER_EIGO_CONTEXT_PATH}/admin/officePortfolio/jitsuryoku_d.cfm?rno=${rno}&course_no=${course_no}&batch_date=${batch_date}&class_end_flg=${class_end_flg}&batch_date_string=${batch_date_string}`;
  const options = {
    name: 'cwDetailWindow',
    width: 800,
    height: 450,
  };
  openWindow(url, options);
}
/**
 * ブック受講状況画面を開く
 */
function openCWListWindow(rno, course_no, contract_no, batch_date_string) {
  const url = `/${SUPER_EIGO_CONTEXT_PATH}/admin/officePortfolio/course_user.cfm?course_no=${course_no}&contract_no=${contract_no}&rno=${rno}&batch_date_string=${batch_date_string}`;
  const options = {
    name: 'cwWindow',
    width: 1000,
    height: 700,
  };
  openWindow(url, options);
}


/**
 * ブックプレビューを開く
 */
function openCourseworkPreviewWindow(url) {
  const options = {
    name: 'mywindow1',
    width: 1020,
    height: 700,
  };
  openWindow(url, options);
}

/**
 * 単発問題プレビュー画面を開く
 * @param question_no
 */
function openAuthoringQuestionPreviewWindow(question_no, au_schm) {
  let url = `/${SUPER_EIGO_CONTEXT_PATH}/lplayer/index_waku.cfm?previewType=single&qno=${question_no}&isPreview=true&type=normal&schm=${au_schm}`;
  if (typeof book_type !== 'undefined'){
    url = `/${SUPER_EIGO_CONTEXT_PATH}/lplayer/index_waku.cfm?previewType=single&qno=${question_no}&isPreview=true&type=normal&schm=${au_schm}&book_type=${book_type}`;
  }

  const options = {
    name: 'mywindow2',
    width: 1000,
    height: 700,
  };
  openWindow(url, options);
}
/**
 * 単発問題プレビュー画面を開く
 * @param question_no
 */
function openCPQuestionPreviewWindow(question_no) {
  const url = `/${SUPER_EIGO_CONTEXT_PATH}/lplayer/index.cfm?previewType=single&qno=${question_no}&isPreview=true&type=normal`;
  const options = {
    name: 'mywindow2',
    width: 1000,
    height: 700,
  };
  openWindow(url, options);
}
/**
 * 問題集複合問題プレビュー画面を開く
 * @param url
 */
function openCombinationQuestionPreviewWindow(url) {
  // const url = `/${SUPER_EIGO_CONTEXT_PATH}/lplayer/index.cfm?previewType=single&qno=${question_no}&isPreview=true&type=normal`;
  const options = {
    name: 'mywindow2',
    width: 1000,
    height: 700,
  };
  openWindow(url, options);
}

export {
  openFlashWindow,
  openVcMyPortfolioWindow,
  openPortfolioWindow,
  openAddClassUserWindow,
  openAddClassUserForIdWindow,
  openDeleteClassUserWindow,
  openEditSchrduleWindow,
  info_release,
  openSendMailWindow,
  openSendMailContractWindow,
  openMailUserSearchWindow,
  openUserSearchWindow,
  openUserSearchQuestWindow,
  openBookPreviewWindow,
  openContractBookPreviewWindow,
  openAssignPreviewWindow,
  openSingleQuestionPreviewWindow,
  openCombinationQuestionPreviewWindow,
  openQuestionPreviewWindow,
  openContractQuestionPreviewWindow,
  openWeeklyPreviewWindow,
  openVCResultWindow,
  openVCMyPortfolioResultWindow,
  openVCCorseworkWindow,
  openVCListWindow,
  openVCResetListWindow,
  openCWDetailListWindow,
  openCWListWindow,
  openCourseworkPreviewWindow,
  openAuthoringQuestionPreviewWindow,
  openCPQuestionPreviewWindow,
};



// WEBPACK FOOTER //
// ./es6/admin-common-js/apps/openWindowFunc.js